const IndicationBadge = ({
  indicationText,
  colorHex,
}: {
  indicationText: string;
  colorHex: string;
}) => {
  // rendering indication badge component here
  return (
    <div className='flex items-center gap-1'>
      <div
        style={{ backgroundColor: colorHex }}
        className='h-2 w-2 rounded-full'
      ></div>

      <p className='text-xs text-legal-dark-blue font-semibold capitalize'>
        {indicationText}
      </p>
    </div>
  );
};

export default IndicationBadge;
